import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cx } from './cx';

export function Container({ narrow = false, className, ...props }: ComponentPropsWithoutRef<'div'> & { narrow?: boolean }) {
  return <div className={cx('wrap', narrow && 'wrap--narrow', className)} {...props} />;
}

export function Section({ alt = false, tight = false, className, ...props }: ComponentPropsWithoutRef<'section'> & { alt?: boolean; tight?: boolean }) {
  return <section className={cx('section', alt && 'section--alt', tight && 'section--tight', className)} {...props} />;
}

export function SectionHead({
  eyebrow,
  title,
  lead,
  center = false,
  as: Heading = 'h2',
  className,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  lead?: ReactNode;
  center?: boolean;
  as?: 'h1' | 'h2';
  className?: string;
}) {
  return (
    <div className={cx('section-head', center && 'section-head--center', className)}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <Heading>{title}</Heading>
      {lead && <p className="lead">{lead}</p>}
    </div>
  );
}
